export default {
  firstName: "",
  lastName: "",
  emailAddress: "",
  phoneNumber: "",
  streetAddress: "",
  country: "",
  clubId: ""
}
